<div class="content-area">
  <div class="row pt-3">
    <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 mx-auto">
      <div class="back-btn-container pointer" (click)="goBack()">
        <img class="back-arrow" src="assets/images/back-arrow.png" />
        Back
      </div>
      <div class="card shadow text-start p-5 p-2-mobile">
        <div class="card-body p-2">
          <img
            src="assets/images/email-round-img.png"
            alt="Verify Email"
            class="img-fluid mb-4 d-block mx-auto w-60"
          />
          <h4 class="text-center">✉️ Verify Your Email</h4>
          <p class="card-text m-3 mb-5 text-center">
            We've sent a 6-digit code to <strong>{{ email }}</strong>
          </p>
          <form
            [formGroup]="registerForm"
            (ngSubmit)="onSubmit()"
            autocomplete="off"
          >
          <ng-otp-input class="d-flex justify-content-center align-items-center pb-5" 
            [formControl]="registerForm.get('authCode')" [config]="otpConfig"></ng-otp-input>
            <!-- Last Row: Submit Button -->
            <div class="text-start-end">
              <button
                type="submit"
                [disabled]="registerForm.status !== 'VALID'"
                class="btn btn-secondary w-100 mb-4"
              >
                Submit
              </button>
              <p *ngIf="!resend" class="text-center text-primary">
                Didn't receive it? 
                <a
                  href="javascript:;"
                  (click)="onResend()"
                  class="text-primary text-decoration-none"
                >
                  Resend code
                </a>
              </p>
              <p *ngIf="resend" class="text-center text-muted">
                Sending...
              </p>
              <p class="text-center text-muted help-div">
                Need help? 
                <a
                  href="mailto:eu.enterprisesupport@firstorion.com"
                  class="text-primary text-decoration-none"
                >
                  Contact support
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
